var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckIconAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    clipPath: "url(#clip0_8278_1031)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.08997 15.8255C13.0055 15.8255 16.1795 12.6515 16.1795 8.73597C16.1795 4.82045 13.0055 1.64648 9.08997 1.64648C5.17445 1.64648 2.00049 4.82045 2.00049 8.73597C2.00049 12.6515 5.17445 15.8255 9.08997 15.8255Z",
    stroke: "#8A6CC8",
    strokeWidth: 1.59513,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.96289 8.73577L8.38079 10.1537L11.2166 7.31787",
    stroke: "#8A6CC8",
    strokeWidth: 1.59513,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8278_1031"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.0148,
    height: 17.0148,
    fill: "white",
    transform: "translate(0.58252 0.228516)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIconAlt);
export default __webpack_public_path__ + "static/media/check-icon-alt.87d79227a9116dd65ad5ca4560cced39.svg";
export { ForwardRef as ReactComponent };